import { jsx } from 'react/jsx-runtime';
import { ModalBack } from './Modal.Back/Modal.Back.es.js';
import { ModalBasicClose } from './Modal.BasicClose/Modal.BasicClose.es.js';
import { ModalBody } from './Modal.Body/Modal.Body.es.js';
import { ModalClose } from './Modal.Close/Modal.Close.es.js';
import { ModalProvider } from './Modal.Context/Modal.Context.es.js';
import { ModalCoolwhip } from './Modal.Coolwip/Modal.Coolwip.es.js';
import { ModalFooter } from './Modal.Footer/Modal.Footer.es.js';
import { ModalHeader } from './Modal.Header/Modal.Header.es.js';
import * as index from './Modal.Layout/index.es.js';
import { ModalScreen } from './Modal.Screen/Modal.Screen.es.js';
import { ModalSubtitle } from './Modal.Subtitle/Modal.Subtitle.es.js';
import { ModalTitle } from './Modal.Title/Modal.Title.es.js';

/**
 * Modal Component with Context Provider.
 */ const Modal = ({ open, size, disableClose, disableCloseOutside, disableBack, onBack, onCloseStart, onCloseEnd, className, coolwhip, ...rest })=>{
    return jsx(ModalProvider, {
        coolwhip: coolwhip,
        disableBack: disableBack,
        disableClose: disableClose,
        disableCloseOutside: disableCloseOutside,
        onBack: onBack,
        onCloseEnd: onCloseEnd,
        onCloseStart: onCloseStart,
        open: open,
        size: size,
        children: jsx(ModalScreen, {
            className: className,
            ...rest
        })
    });
};
Modal.displayName = 'Modal';
Modal.Header = ModalHeader;
Modal.Footer = ModalFooter;
Modal.Title = ModalTitle;
Modal.Subtitle = ModalSubtitle;
Modal.Body = ModalBody;
Modal.Close = ModalClose;
Modal.Back = ModalBack;
Modal.BasicClose = ModalBasicClose;
Modal.Coolwhip = ModalCoolwhip;
Modal.Layout = index;

export { Modal, Modal as default };
//# sourceMappingURL=Modal.es.js.map
